import React, { useEffect, useState, useContext, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Button from '@components/Button';
import ComboBox from '@components/ComboBox';
import { findFontByNameOrId, getFonts } from 'utils/fonts';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { IDSConfig, IBrandConfigFont } from '@state/dsconfig/types';
import _ from 'lodash';

const FontReplacementItem:React.FC<IProps> = (props) => {
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [fontsList, setFontsList] = useState<IBrandConfigFont[]>([]);
  const [incomPatibleFont, setIncompatibleFont] = useState<IBrandConfigFont | undefined>(undefined)
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (fontsList.length===0) {
        const list = getFonts(dsConfig);
        setFontsList(list);
      }
    } else {
      setFontsList([]);
    }
  }, [isOpen]);

  useEffect(() => {
    setIncompatibleFont(findFontByNameOrId(dsConfig.brands, "id", props.incompatibleFontReplace.incompatibleFont ?? ''));
  }, [props.incompatibleFontReplace.incompatibleFont]);
  

  const handleChangeFontFamily = (id: string, value: string|undefined) => {
    const font = findFontByNameOrId(dsConfig.brands, "name", value ?? '');
    if (value !== props.incompatibleFontReplace.fontReplace && font) {
      props.onFontSelect(props.incompatibleFontReplace.incompatibleFont, font.id);
    } 
  }

  const returnFontValue = () => {
    let fontName = props.incompatibleFontReplace?.fontReplace;
    const font = findFontByNameOrId(dsConfig.brands, "id", fontName ?? "");
    if (font) fontName = font.name;
    return fontName;
  }

  return (
    <S.FontReplaceContainer columnPosition={(props.index % 2)=== 0?0:1}>
      <S.FontReplaceItemsContainer>
        <S.FontTitle>
          {incomPatibleFont?.name ?? props.incompatibleFontReplace.incompatibleFont}
        </S.FontTitle>
        <S.ReplaceMessage>
          Replace With
        </S.ReplaceMessage>
        <ComboBox
          id={`${"cmbFontReplace" + props.incompatibleFontReplace.incompatibleFont.replace(" ","_")}`}
          placeholder={"Search Fonts"}
          options={_.flatten(fontsList.map(font => {return font.name}))}
          required={false}
          disabled={false}
          position={"bottom"}
          chooseOption={handleChangeFontFamily}
          optionContainerStyle={{
            maxHeight: `269px`,
          }}
          value={returnFontValue()}
          setIsOpen={setIsOpen}
          pageSize={10} 
        />
      </S.FontReplaceItemsContainer>
    </S.FontReplaceContainer>
  );
}

export default FontReplacementItem